import { ThunkAction } from 'redux-thunk';
import { GlobalState } from '../../store/reducers';
import { UpdateGenieProfilesAction } from '../../store/actions/login';
import { Modal } from 'antd';
import { IMilestoneCategory } from '../../api/getMilestone';
import { mileStoneCategoryName } from './constants/milestones';

export const openMilestonConfimationDialog = (
    onYes: any,
    onNo?: any,
    category?: IMilestoneCategory[],
): ThunkAction<Promise<void>, GlobalState, null, UpdateGenieProfilesAction> => {
    return async (dispatch): Promise<void> => {
        const dialog = Modal.confirm({
            closable: true,
            maskClosable: true,
            onOk: onYes,
            onCancel: (args) => {
                if (args?.triggerCancel) {
                    dialog?.destroy();
                } else {
                    onNo && onNo();
                    dialog?.destroy();
                }
            },
            okText: 'Yes',
            cancelText: 'No',
            width: '35%',
            type: 'confirm',
            title: (
                <p className="text-16 max-w-386 font-400">
                    Do you want to mark all previous milestones achieved
                    {category && category.length ? ' for ' : ''}
                    {category && category.length ? (
                        <span className="text-darwin-accent-bright-blue-800">
                            {category.map((cat) => mileStoneCategoryName[cat]).join(', ')}
                        </span>
                    ) : null}
                    ?
                </p>
            ),
        });
    };
};

export const deleteMilestonConfimationDialog = (
    milestone: string,
    ageGroup: string,
    onYes?: any,
    onNo?: any,
): ThunkAction<Promise<void>, GlobalState, null, UpdateGenieProfilesAction> => {
    return async (dispatch): Promise<void> => {
        Modal.confirm({
            closable: true,
            maskClosable: true,
            onOk: onYes,
            onCancel: onNo,
            okText: 'Yes, delete',
            cancelText: 'Cancel',
            width: '35%',
            type: 'confirm',
            content: (
                <p className="text-16 text-center font-400">
                    Are you sure you want to delete "<b>{milestone}</b>" from age group{' '}
                    <b>{ageGroup}</b> ?
                </p>
            ),
        });
    };
};

export const clearMilestonConfirmationDialog = (
    onYes?: any,
    onNo?: any,
): ThunkAction<Promise<void>, GlobalState, null, UpdateGenieProfilesAction> => {
    return async (dispatch): Promise<void> => {
        const dialog = Modal.confirm({
            closable: true,
            maskClosable: true,
            onOk: () => {
                onYes();
                dialog.destroy();
            },
            onCancel: onNo ? onNo : () => dialog.destroy(),
            okText: 'Yes, clear',
            cancelText: 'Cancel',
            width: '35%',
            type: 'warning',
            title:
                'This will clear new modifications made in the current session. Are you sure you want to clear?',
        });
    };
};
